import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ChangePasswordComponent from "./ChangePasswordComponent";

import Logo from "../common/Logo";
import UrlHelper from "../../utilities/UrlHelper";
import { getPasswordSettingsByTicket } from "../../actions/OrganizationActions";
import { changePasswordAndLogin } from "../../actions/UserActions";

export class ExpiredPasswordPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            selectedProduct: UrlHelper.parseUrl().query.a,
            returnUrl: UrlHelper.parseUrl().query.ReturnUrl
        };

        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        import('./_passwordStyles.scss');
        const ticket = UrlHelper.parseUrl().query.ticket;
        this.props.getPasswordSettingsByTicket(ticket);
    }


    close () {
        window.top.close();
    }

    onSave (newPassword, currentPassword) {
        const request = {
            Ticket: UrlHelper.parseUrl().query.ticket,
            NewPassword: newPassword,
            CurrentPassword: currentPassword,
            product: this.state.selectedProduct,
            returnUrl: this.state.returnUrl
        };

        this.props.loginAndChangePassword(request);
    }

    render () {
        if (this.props.isAuthenticated && this.props.redirectTo != null) {
            window.location = this.props.redirectTo;
        }

        if (this.props.passwordValidationRules == null)
            return null;

        return (<div id="resetPasswordPage">
            <div className="row">
                <div className="col-md-3">
                    <Logo/></div>
            </div>
            <div className="row">
                <div className="col-md-4 col-md-offset-4">
                    <h2>Reset Expired Password</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 col-md-offset-4">
                    <ChangePasswordComponent
                        onSave={this.onSave} errorSummary="Unable to reset password"
                        passwordValidationRules = {this.props.passwordValidationRules}
                        passwordValidationUserData={this.props.passwordValidationUserData}
                        serverFailureMessage = {this.props.serverFailureMessage}
                    />
                </div>
            </div>
        </div>);

    }
}

ExpiredPasswordPage.propTypes = {
    redirectTo: PropTypes.string,
    getPasswordSettingsByTicket: PropTypes.func.isRequired,
    loginAndChangePassword: PropTypes.func,
    passwordValidationUserData: PropTypes.object,
    isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
    redirectTo: state.appState.redirectTo,
    isAuthenticated: state.userState.isAuthenticated,
    serverFailureMessage: state.userState.serverFailureMessage,
    passwordValidationUserData: state.userState.passwordValidationUserData,
    passwordValidationRules: state.userState.passwordValidationRules
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getPasswordSettingsByTicket: (ticket) => dispatch(getPasswordSettingsByTicket(ticket)),
        loginAndChangePassword: (request) => dispatch(changePasswordAndLogin(request))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredPasswordPage);

